import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { format } from 'date-fns/format';
import React from 'react';

interface BetData {
  number: string;
  count: number;
  points: number;
}

interface BettingSlipProps {
  date: Date;
  games: BetData[];
  totalBets: number;
  totalPointsSum: number;
  gameType: string;
  game: string;
  gameTime: string;
}

// Update the styles object
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  header: {
    marginBottom: 20,
  },
  headerText: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 10,
    fontWeight: 'bold',
  },
  dateInfo: {
    marginBottom: 15,
  },
  infoRow: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  label: {
    width: 120,
    fontWeight: 'bold',
  },
  betContainer: {
    marginTop: 20,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  betSection: {
    marginVertical: 10,
    padding: 10,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  betGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
  },
  betItem: {
    width: '23%',
    marginBottom: 5,
    padding: 8,
    borderWidth: 1,
    borderColor: '#000',
    backgroundColor: '#f8f9fa',
  },
  betText: {
    fontSize: 9,
    marginBottom: 3,
    fontWeight: 'bold',
  },
  footer: {
    position: 'absolute',
    border: '1px solid #ccc',
    bottom: 20,
    left: 20,
    right: 20,
    textAlign: 'center',
    fontSize: 8,
    color: '#666',
  },
  summarySection: {
    marginTop: 20,
    padding: 10,
    borderTop: 1,
    borderTopColor: '#000',
  },
  summaryText: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
  }
});


const BettingSlipPDF: React.FC<BettingSlipProps> = ({
  date,
  games,
  totalBets,
  totalPointsSum,
  gameType,
  game,
  gameTime
}) => (
    <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text style={styles.headerText}>Game Report</Text>
        
        <View style={styles.dateInfo}>
          <View style={styles.infoRow}>
            <Text style={styles.label}>Game:</Text>
            <Text>{game} - {gameType}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.label}>Date:</Text>
            <Text>{format(date, 'dd-MM-yyyy')}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.label}>Result Time:</Text>
            <Text>{gameTime}</Text>
          </View>
        </View>
      </View>
  
      <View style={styles.betContainer}>
        <View style={styles.betSection}>
          <Text style={styles.sectionTitle}>Bet Details</Text>
          <View style={styles.betGrid}>
            {games.map((bet, index) => {
              // Format the number with labels for 99999 values
              let displayNumber = bet.number;
              const parts = bet.number.split('*');
              
              if (parts.length === 6) {
                const [fd, ld, op, ep, r, g] = parts;
                const formattedParts = [
                  fd !== '99999' ? fd : 'FD',
                  ld !== '99999' ? ld : 'LD',
                  op !== '99999' ? op : 'OP',
                  ep !== '99999' ? ep : 'EP',
                  r !== '99999' ? r : 'R',
                  g !== '99999' ? g : 'G'
                ];
                
                displayNumber = formattedParts.join('*');
              }
              
              return (
                <View key={index} style={styles.betItem}>
                  <Text style={styles.betText}>Number: {displayNumber}</Text>
                  <Text style={styles.betText}>Count: {bet.count}</Text>
                  <Text style={styles.betText}>Points: {bet.points}</Text>
                </View>
              );
            })}
          </View>
        </View>
      </View>

      <View style={styles.summarySection}>
        <Text style={styles.summaryText}>Total Bets: {totalBets}</Text>
        <Text style={styles.summaryText}>Total Points: {totalPointsSum}</Text>
      </View>
  
      <Text style={styles.footer}>
        Generated by BizzBoy.com on {format(new Date(), 'dd-MM-yyyy hh:mm a')}
      </Text>
    </Page>
  </Document>
);

export default BettingSlipPDF;